import React from 'react';
import { reportError } from '../../services/logs/logs.service';
import classes from './base-error-boundary.module.scss';

type AppErrorBoundaryProps = {
  children: React.ReactNode;
};

type AppErrorBoundaryState = {
  hasError: boolean;
};

export class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  constructor(props: AppErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo): void {
    // Keep runtime failures visible in logs while preventing full app crash loops.
    // eslint-disable-next-line no-console
    console.error('Unhandled React render error', error);
    reportError({
      message: error instanceof Error ? error.message : 'Unhandled React render error',
      errorName: error instanceof Error ? error.name : 'RenderError',
      trace: error instanceof Error ? error.stack : undefined,
      context: { componentStack: info.componentStack },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={classes.container}>
          <h1> משהו בלתי צפוי קרה! </h1>
          <a href="/" style={{ textDecoration: 'underline', color: 'blue' }}>
            רענן מערכת ונסה שנית
          </a>
        </div>
      );
    }

    return this.props.children;
  }
}
